import {createReducer} from '@reduxjs/toolkit'
import {loadCalendarEvents, loadEventsPage, loadFeaturedEvent, setFilterType} from '../actions/events'
import {LOAD_MEMBERS_FOR_EVENTS_OLD, loadMembersForEvents} from '../actions/members'
import {Events} from '../types/state'

const defaultState: Events = {
  events: [],
  moreLoading: false,
  hasMore: false,
  filterType: null,
}

export const events = createReducer(defaultState, builder =>
  builder
    .addCase(loadEventsPage.fulfilled, (state, {meta, payload}) => {
      const {offset} = meta.arg
      const reset = offset === 0

      state.events = reset ? payload.events : [...state.events, ...payload.events]
      state.hasMore = payload.hasMore
      state.moreLoading = false
    })
    .addCase(loadEventsPage.pending, (state, {meta}) => {
      const {offset} = meta.arg
      state.moreLoading = offset !== 0
    })
    .addCase(loadEventsPage.rejected, state => {
      state.moreLoading = false
    })
    .addCase(loadFeaturedEvent.fulfilled, (state, {payload}) => {
      state.events = payload.featuredEvent ? [payload.featuredEvent] : []
    })
    .addCase(loadCalendarEvents.fulfilled, (state, {meta, payload}) => {
      if (payload) {
        const reset = meta.arg.fullReset
        const loadedEvents = reset ? [] : state.events
        const existingEventIds = loadedEvents.map(event => event.id)
        const newEvents = payload.events.filter(event => !existingEventIds.includes(event.id))

        state.events = [...loadedEvents, ...newEvents]
        state.hasMore = false
        state.moreLoading = false
      }
    })
    .addCase(setFilterType, (state, {payload}) => {
      state.filterType = payload
    })
    .addCase(loadMembersForEvents.fulfilled, (state, {payload}) => {
      state.events = state.events.map(event => ({
        ...event,
        ...(payload[event.id] || {}),
      }))
    })
    .addMatcher(
      action => action.type === LOAD_MEMBERS_FOR_EVENTS_OLD.SUCCESS,
      (state, {payload}) => {
        const guestLists = payload as GuestLists

        state.events = state.events.map(event => ({
          ...event,
          ...(guestLists[event.id] || {}),
        }))
      },
    ),
)
